import React, { useState, useEffect } from 'react';
import {Button,ButtonGroup,Form, Modal,Card,Col,Row} from 'react-bootstrap';
import { Table, Header } from "semantic-ui-react";
import {Auth} from 'aws-amplify';

function Contact(){
  return (
	<div style={{
	background:"#FFFFFF"
	    
	}}>
		<Row>
			<Col md={2}>
			</Col>
			<Col md={8}>
				<div style={{
					
					height:"100px"
				}}>
				</div>
				<div>
					 <Header size='large'><span style={{color:"#6495ED"}}>Contact us, if you have any questions or suggestions:</span></Header>
				</div>
				<div style={{
					
					height:"50px"
				}}>
				</div>
				<div>
					 
					 <Header size='medium'><span style={{color:"#6495ED"}}  >E-mail : <a href="mailto:plantp450s_admin@tib.cas.cn"><u>plantp450s_admin@tib.cas.cn</u></a></span></Header>
					 <Header size='medium'><span style={{color:"#6495ED"}}>Address : Tianjin Institute of Industrial Biotechnology, Chinese Academy of Sciences</span></Header>
					
					
				</div>
				<div style={{
					
					height:"150px"
				}}>
				</div>
			</Col>
			<Col md={2}>
			</Col>
		</Row>
	</div>
    
  );
}

export default Contact;